import { call, put, takeEvery } from "redux-saga/effects";
import {
  ADD_NEW_Payment,
  GET_PARTICIPANT_PAYMENT,
  GET_PARTICIPANT_SCHEME_LIST,
  UPDATE_NEW_PAYMENT,
  GET_DELETED_PAYMENTS,
  DELETE_PAYMENT,
  CONFIRM_PAYMENT,
  GET_ANALYTE_REPORT2,
  GET_ANALYTE_EVALUATION_REPORT,
  GET_PARTICIPANT_PERFORMANCE_REPORT,
  GET_ANALYTE_EVALUATION_LAB,
  GET_FINANCIAL_FORECAST,
} from "./actionTypes";
import {
  addNewPaymentSuccess,
  addNewPaymentFail,
  getparticipantpaymentSuccess,
  getparticipantpaymentFail,
  getParticipantSchemelistSuccess,
  getParticipantSchemelistFail,
  updatePayment,
  updatePaymentSuccess,
  updatePaymentFail,
  deletePaymentSuccess,
  deletePaymentFail,
  confirmpaymentSuccess,
  confirmpaymentFail,
  getanalytereport2Success,
  getanalytereport2Fail,
  getanalyteevaluationreportSuccess,
  getanalyteevaluationreportFail,
  getparticipantperformancereportSuccess,
  getparticipantperformancereportFail,
  getanalyteevaluationLabSuccess,
  getanalyteevaluationLabFail,
  getfinancialforecastSuccess,
  getfinancialforecastFail,
  getDeletedPaymentsSuccess,
  getDeletedPaymentsFail,
} from "./actions";
import {
  addNewPayment,
  getParticipantPayment,
  getParticipantSchemelist,
  updateNewPayment,
  getDeletedPayments,
  deletePayment,
  confirmpayment,
  apiGetAnalyteReport2,
  apigetanalyteevaluationreport,
  getparticipantperformanceApi,
  apigetanalyteevaluationLab,
  getfinancialforecastApi,
} from "../../helpers/django_api_helper";

function* onAddNewPayment(object) {
  console.log("data in saga1", object.payload.payment);
  console.log("data in saga222222", object.payload.id);
  try {
    const response = yield call(
      addNewPayment,
      object.payload.payment,
      object.payload.id,
    );
    yield put(addNewPaymentSuccess(response));
  } catch (error) {
    yield put(addNewPaymentFail(error));
  }
}
function* fetchParticipantPayment() {
  try {
    const response = yield call(getParticipantPayment);
    console.log("Full API Response:", response);

    // Access the 'payments' array inside the response
    const payments = response.payments || [];

    if (payments.length > 0) {
      yield put(getparticipantpaymentSuccess(payments));
    } else {
      throw new Error("No data returned");
    }
  } catch (error) {
    console.error("Error fetching Participant Payment:", error);
    yield put(getparticipantpaymentFail(error));
  }
}
function* onUpdatePayment({ payload: payment }) {
  try {
    console.log("🧾 Saga received payment payload:", payment); // ✅ Check here

    const response = yield call(updateNewPayment, payment);

    yield put(updatePaymentSuccess({ ...response, id: payment.id }));
  } catch (error) {
    console.error("❌ Error in onUpdatePayment saga:", error);
    yield put(updatePaymentFail(error));
  }
}

function* fetchParticipantSchemelist(action) {
  try {
    const response = yield call(getParticipantSchemelist, action.payload);
    console.log("fetchParticipantSchemelist raw response:", response);

    // API returns { status: 'success', data: [...], csr_staff: [...] }
    // response.data can itself be an array OR an object wrapping { data, csr_staff }
    // depending on whether the api helper already unwraps axios' response.data.
    const list = response?.data?.data ?? response?.data ?? [];
    const csrStaff = response?.csr_staff ?? response?.data?.csr_staff ?? [];

    console.log("fetchParticipantSchemelist parsed list:", list);
    console.log("fetchParticipantSchemelist parsed csrStaff:", csrStaff);

    if (!Array.isArray(list) || list.length === 0) {
      console.log("fetchParticipantSchemelist: list is empty, dispatching with empty schemes");
      yield put(
        getParticipantSchemelistSuccess({
          schemes: [],
          csr_staff: csrStaff,
        })
      );
      return;
    }

    const first = list[0];
    console.log("fetchParticipantSchemelist first item:", first);

    yield put(
      getParticipantSchemelistSuccess({
        schemes: list,
        participant_name: first.participant_name,
        membership_status: first.membership_status,
        csr_staff: csrStaff,
      })
    );

    console.log("fetchParticipantSchemelist: success dispatched with", {
      schemesCount: list.length,
      participant_name: first.participant_name,
      membership_status: first.membership_status,
      csrStaffCount: csrStaff.length,
    });
  } catch (error) {
    console.error("Error in Saga:", error);
    yield put(getParticipantSchemelistFail(error));
  }
}
function* fetchDeletedPayments(action) {
  try {
    const response = yield call(getDeletedPayments, action.payload);
    yield put(getDeletedPaymentsSuccess(response.payments || []));
  } catch (error) {
    console.error("Error fetching deleted payments:", error);
    yield put(getDeletedPaymentsFail(error));
  }
}

function* onDeletePayment({ payload }) {
  try {
    const response = yield call(deletePayment, payload);
    yield put(deletePaymentSuccess(payload.id));
  } catch (error) {
    console.error("❌ Error deleting payment:", error);
    yield put(deletePaymentFail(error));
  }
}

function* confirmPaymentSaga(action) {
  try {
    const response = yield call(confirmpayment, action.payload); // ✅ FIXED
    console.log("Full API Response:", response);

    yield put(confirmpaymentSuccess(response));
  } catch (error) {
    console.error("Error confirming payment:", error);
    yield put(confirmpaymentFail(error));
  }
}

function* fetchAnalyteReport2(action) {
  try {
    const response = yield call(apiGetAnalyteReport2, action.payload);
    console.log("Full API Response:", response);

    yield put(getanalytereport2Success(response)); // ✅ send full response (analyte + schemes)
  } catch (error) {
    console.error("Error fetching analyte data", error);
    yield put(getanalytereport2Fail(error));
  }
}
function* fetchAnalyteEvaluationReport(action) {
  try {
    const response = yield call(apigetanalyteevaluationreport, action.payload);
    console.log("Full API Response:", response);

    yield put(getanalyteevaluationreportSuccess(response)); // ✅ send full response (analyte + schemes)
  } catch (error) {
    console.error("Error fetching analyte data", error);
    yield put(getanalyteevaluationreportFail(error));
  }
}

function* fetchParticipantPerformance(action) {
  try {
    const { scheme_id, user_id } = action.payload;
    const response = yield call(
      getparticipantperformanceApi,
      scheme_id,
      user_id,
    );

    console.log("🌀 Saga received API response:", response);

    if (response?.status === 200) {
      yield put(getparticipantperformancereportSuccess(response));
    } else {
      yield put(getparticipantperformancereportFail(response));
    }
  } catch (error) {
    console.error(
      "Saga error:",
      error.response?.data || error.message || error,
    );
    yield put(getparticipantperformancereportFail(error));
  }
}

function* fetchAnalyteEvaluationLab(action) {
  try {
    const response = yield call(apigetanalyteevaluationLab, action.payload);
    console.log("Full API Response:", response);

    yield put(getanalyteevaluationLabSuccess(response)); // ✅ send full response (analyte + schemes)
  } catch (error) {
    console.error("Error fetching analyte data", error);
    yield put(getanalyteevaluationLabFail(error));
  }
}
function* fetchFinancialForecast() {
  try {
    const response = yield call(getfinancialforecastApi);

    console.log("Full API Response:", response);

    if (response.status === "success") {
      // 🔥 Send full response as it is
      yield put(getfinancialforecastSuccess(response));
    } else {
      throw new Error("Invalid response");
    }
  } catch (error) {
    console.error("Error fetching Participant Payment:", error);
    yield put(getfinancialforecastFail(error.message));
  }
}
function* PaymentSaga() {
  yield takeEvery(ADD_NEW_Payment, onAddNewPayment);
  yield takeEvery(GET_PARTICIPANT_PAYMENT, fetchParticipantPayment);
  yield takeEvery(GET_PARTICIPANT_SCHEME_LIST, fetchParticipantSchemelist);
  yield takeEvery(UPDATE_NEW_PAYMENT, onUpdatePayment);
  yield takeEvery(GET_FINANCIAL_FORECAST, fetchFinancialForecast);
  yield takeEvery(DELETE_PAYMENT, onDeletePayment); // ✅ Add this line
  yield takeEvery(GET_DELETED_PAYMENTS, fetchDeletedPayments);
  yield takeEvery(CONFIRM_PAYMENT, confirmPaymentSaga);
  yield takeEvery(GET_ANALYTE_REPORT2, fetchAnalyteReport2);
  yield takeEvery(GET_ANALYTE_EVALUATION_REPORT, fetchAnalyteEvaluationReport);
  yield takeEvery(
    GET_PARTICIPANT_PERFORMANCE_REPORT,
    fetchParticipantPerformance,
  );
  yield takeEvery(GET_ANALYTE_EVALUATION_LAB, fetchAnalyteEvaluationLab);
}
export default PaymentSaga;
